'use strict';

var endOfDay = require('date-fns/endOfDay');
var parsers = require('../parsers.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var endOfDay__default = /*#__PURE__*/_interopDefault(endOfDay);

const dateToEndOfDayISODateTimePart = (date) => {
  return parsers.dateToISODateTimePart(endOfDay__default(date));
};

exports.dateToEndOfDayISODateTimePart = dateToEndOfDayISODateTimePart;
//# sourceMappingURL=dateToEndOfDayISODateTimePart.cjs.map
